import { PermissionsService } from 'app/service/permission/permissions.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate, } from '@angular/router';
import { EventEmitterService } from 'app/service/event-emitter-service';
import { AuthSsoService } from 'app/sso/auth-sso.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private permission: PermissionsService,
    private authSso: AuthSsoService,
    private router: Router,
    ) {  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.authSso.initialize().then(() => {
      const ticket = this.authSso.getAlfrescoTicket();
      // Sem sessao do SSO nesta aba: entra por ele, que volta sem senha enquanto a sessao dele vale.
      if (!this.authSso.hasSsoSession() || !ticket) {
        this.saveRouteParams(route);
        if (!this.authSso.login(state.url)) {
          // Login em ciclo: o /sso-login mostra o erro e o botao para tentar de novo.
          this.router.navigate(['/sso-login']);
        }
        return false;
      }

      // Como antes, a tela abre e o ticket e conferido no Alfresco em paralelo; o header e o menu esperam esse ok.
      this.permission.getIsLogged(ticket).subscribe(() => {
        EventEmitterService.get('isLoggedIn').emit(true);
      }, () => {
        // Ticket morto no Alfresco: o SSO devolve outro ou, se a sessao dele acabou, encerra tudo.
        this.saveRouteParams(route);
        this.authSso.recoverAlfrescoTicket(state.url, ticket).then(renewed => {
          if (renewed) {
            EventEmitterService.get('isLoggedIn').emit(true);
          }
        });
      });
      return true;
    });
  }

  // O login antigo carregava as permissoes da empresa do id da rota (ex.: link direto para um cliente).
  private saveRouteParams(route: ActivatedRouteSnapshot) {
    if (route.params != null && route.params.id !== undefined) {
      sessionStorage.setItem('params', route.params.id);
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/guards/auth.guard.ts